import { Component, Inject, ViewEncapsulation, ViewChild, ElementRef, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatChipInputEvent, MatAutocompleteSelectedEvent } from '@angular/material';
import { I18N } from 'ess-plugin-base';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { debounceTime, switchMap, finalize, tap } from 'rxjs/operators';
import { FileProvider } from '../file.provider';
import { UIService } from '../../ui.service';
import { Router } from '@angular/router';
import { Constants } from '../../Constants';
import { HttpParams } from '@angular/common/http';

export interface ShareData {
    title: string;
    path: string;
    files: string[];
    resources: string[];
}

@Component({
    selector: 'file-share-dialog',
    templateUrl: './share.dialog.html',
    styleUrls: ['./share.dialog.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class FileShareDialog implements OnChanges, OnInit {

    @ViewChild('toUserInput', {static: true}) 
    toUserInput: ElementRef;
  
    to_users: any[] = [];

    filteredTo: any[] = [];   //Observable<any[]>;

    toUsersCtl = new FormControl();

    isLoading: boolean;
  
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    // @ViewChild('input', {static: true})
    // input: ElementRef;

    // newFolder: string = '';

    constructor(public dialogRef: MatDialogRef<FileShareDialog>, public i18n: I18N, 
        private ui: UIService, private router: Router,
        private provider: FileProvider,
        @Inject(MAT_DIALOG_DATA) public data: ShareData) {

        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    ngOnInit() {
        this.toUsersCtl.valueChanges
        .pipe(
          debounceTime(500),
          tap(() => {
            this.isLoading = null;
          }),
          switchMap((name: string) => this.provider.lookupUsers(name)
          .pipe(
              finalize(() => this.isLoading = null),
            )
          )
        )
        .subscribe((result : any) => { 
            this.filteredTo = result.data;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        // console.log("Updating ", this.data);
        // if (this.data) {
        //     this.input.nativeElement.value = this.data.name;
        // }
    }

    add(event: MatChipInputEvent): void {
        // console.log(event);
        const input = event.input;
        // const value = event.value;
    
        // if ((value || '').trim()) {
        //   this.to_users.push({username: value.trim()});
        // }
    
        // this.to_users.push(value);
        // Add our fruit
        // if ((value || '').trim()) {
        //   this.to_users.push({full_name: value.trim()});
        // }
    
        // console.log(event);
        if (event && event.value) {
          let user = event.value;
          if (user.includes('@')) {   //} && this.filteredTo.length == 0) {
    
              if (!this.to_users.includes(user)) {
                this.to_users.push({full_name: '', username: event.value});   // viewValue
              }
          }
        }
    
        // this.toUserInput.nativeElement.value = '';
        this.toUsersCtl.setValue(null);
    
    
        // Reset the input value
        if (input) {
          input.value = '';
        }
    }
    
    remove(array: any[], user: any): void {
        const index = array.indexOf(user);
    
        if (index >= 0) {
          array.splice(index, 1);
        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        
        if (event && event.option) {
            let user = event.option.value;
            if (!this.to_users.includes(user)) {
              
              this.to_users.push(event.option.value);   // viewValue
            }
          }
    
        this.toUsersCtl.setValue(null);
    }    

    copyLink() {
      let url = Constants.protocol + Constants.fileServer + '/file/download';
        
      let params: HttpParams = new HttpParams();
      params = params.append("f", this.data.title);
      params = params.append("guid", this.data.files[0]);

      url += '?' + params;      
      // let url = window.location.href.replace(this.router.url, '') + '/meeting/' + this.data.id;
      
      if (navigator && navigator.clipboard) {
          navigator.clipboard.writeText(url);
      } else {
          let selBox = document.createElement('textarea');
          selBox.style.position = 'fixed';
          selBox.style.left = '0';
          selBox.style.top = '0';
          selBox.style.opacity = '0';
          selBox.value = url;
          document.body.appendChild(selBox);
          selBox.focus();
          selBox.select();
          document.execCommand('copy');
          document.body.removeChild(selBox);
      }
      this.ui.info(url);
  }

    close() {
        this.dialogRef.close();
    }

    // delete() {
    //     this.dialogRef.close('__DELETE__');
    // }

    save() {
        this.data.resources = [];
        for(let to of this.to_users) {
            if (to.username) {
                // let res = {res: 'user-' + to.username, name: to.full_name};
                // this.data.resources.push(res);
                this.data.resources.push('user-' + to.username);
            }
        }
        // this.dialogRef.close(this.data.path + '/' + this.input.nativeElement.value);
        this.dialogRef.close(this.data);
    }

}